import script from "./BlocklyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BlocklyComponent.vue?vue&type=script&setup=true&lang=js"

import "./BlocklyComponent.vue?vue&type=style&index=0&id=e59244a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e59244a0"]])

export default __exports__